import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";
import { Route as DashboardRoute } from "./_layout.index";
import { Id } from "@cvx/_generated/dataModel";
import { api } from "@cvx/_generated/api";
import { convexQuery } from "@convex-dev/react-query";
import { useAccount } from "@/state/useAccount";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

const welcomeSearchSchema = z.object({
  appName: z.string().optional(),
});

export const Route = createFileRoute("/_app/_auth/dashboard/_layout/welcome")({
  component: WelcomeScreen,
  validateSearch: welcomeSearchSchema,
});

export default function WelcomeScreen() {
  const navigate = useNavigate();
  const { contractId } = useAccount();
  const { appName } = Route.useSearch();

  // Fetch campaign details to get the app name if not provided in search params
  const { data: contract } = useQuery({
    ...convexQuery(api.partnerships.getPartnership, {
      partnershipId: contractId as Id<"creatorContracts">,
    }),
    enabled: !!contractId,
  });

  const displayAppName = appName || contract?.app.name || "this";

  // Redirect to dashboard if no contract ID (shouldn't happen, but safety check)
  useEffect(() => {
    if (!contractId) {
      navigate({ to: DashboardRoute.fullPath, replace: true });
    }
  }, [contractId, navigate]);

  const handleGetStarted = () => {
    navigate({ to: DashboardRoute.fullPath, replace: true });
  };

  return (
    <div className="flex min-h-[calc(100vh-200px)] w-full items-center justify-center bg-background">
      <div className="mx-auto max-w-2xl px-6 text-center">
        <h1 className="mb-4 text-4xl font-bold text-primary">
          Welcome to the {displayAppName} challenge!
        </h1>
        <p className="mb-8 text-lg text-primary/80">
          We're excited to have you here, and to help you succeed 🥳
        </p>
        <Button
          onClick={handleGetStarted}
          size="lg"
          className="rounded-full px-12 py-6 text-lg font-semibold"
        >
          Let's get started
        </Button>
      </div>
    </div>
  );
}
